
import { defineComponent, computed, PropType } from 'vue'

export default defineComponent({
  name: 'StarArticleStatement',
  props: {
    article: {
      type: Object as PropType<Record<string, any>>,
      default: () => ({}),
    },
  },
  setup(props) {
    const statementText = computed(() =>
      props.article?.disclaimers ||
      '免责声明：以上内容仅供您参考和学习使用，任何投资建议均不作为您的投资依据；您需自主做出决策，自行承担风险和损失。九方智投提醒您，市场有风险，投资需谨慎。'
    )

    return { statementText }
  },
})
